var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"id":"default-cancel-btn","variant":_vm.stageBack ? 'outline-dark' : 'outline-danger'}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',[_vm._v(_vm._s(_vm.btnLabel))])])])}
var staticRenderFns = []

export { render, staticRenderFns }